import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { callApp } from '@ifeng/callapp';
import styles from './index.css';

class Compet extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        viewData: [],
        isShowMoreBtn: true,
    };

    loadNum = 3;

    componentDidMount() {
        this.setState({
            viewData: this.props.content.slice(0, 3),
        });
    }

    // 判断是否是客户端
    isClient = () => {
        return window && typeof window.grounds !== 'undefined';
    };

    handleMoreBtn = () => {
        const { content } = this.props;

        if (this.isClient()) {
            this.loadNum = this.loadNum + 3;

            this.setState({
                viewData: content.slice(0, this.loadNum),
                isShowMoreBtn: this.loadNum + 3 < content.length,
            });
        } else {
            callApp({
                client: 'newsApp',
                docType: 'web',
                pid: 'https://ishare.ifeng.com/c/s/80kdzDaUKoa',
                kind: 'inter_dsjzt01',
                noKindFrom: 1,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191364941',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8819',
            });
        }
    };

    render() {
        const { viewData, isShowMoreBtn } = this.state;

        return (
            <div className={styles.compet}>
                <div className={styles.competMd}>
                    <img
                        className={styles.competMdImg}
                        src="https://x0.ifengimg.com/ucms/2020_43/BD4D367C5FC2FA4D399C084033A65B09E45BF743_w254_h110.png"
                    />
                </div>
                <div className={styles.competBd}>
                    <div className={styles.competLead}>
                        <div className={`${styles.competLeadMan} ${styles.competLeadBiden}`}>
                            <div className={styles.competLeadManBox}>
                                <img
                                    className={styles.competLeadManPic}
                                    src="https://x0.ifengimg.com/ucms/2020_43/06DE8F3BD6256C94995515508AF7F8E2C3824DF8_w160_h160.png"
                                />
                            </div>
                            <div className={styles.competLeadManBiden}>
                                <p className={styles.competLeadManName}>
                                    拜登<span className={styles.competLeadManBref}> / 民主党</span>
                                </p>
                            </div>
                        </div>
                        <div className={styles.competTrumpVs} />
                        <div className={`${styles.competLeadMan} ${styles.competLeadTrump}`}>
                            <div className={styles.competLeadManBox}>
                                <img
                                    className={styles.competLeadManPic}
                                    src="https://x0.ifengimg.com/ucms/2020_43/8164057AC50A3E1D347CE712E49971E0D1A37912_w160_h160.png"
                                />
                            </div>
                            <div className={styles.competLeadManTrump}>
                                <p className={styles.competLeadManName}>
                                    特朗普<span className={styles.competLeadManBref}> / 共和党</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    {viewData.map((item, index) => (
                        <div key={index} className={styles.competSubject}>
                            <div className={styles.competSubjectMd}>
                                <span className={styles.competSubjectTitle}>
                                    <i className={styles.competSubjectTitleIcon} />
                                    {item.topic}
                                </span>
                            </div>
                            <div className={styles.competSubjectBd}>
                                <div className={styles.competSubjectBiden}>
                                    <div className={styles.competSubjectBdText}>{item.bView}</div>
                                    {item.bImage && (
                                        <div className={styles.competSubjectBdPic}>
                                            <img className={styles.competSubjectBdImage} src={item.bImage} />
                                        </div>
                                    )}
                                </div>
                                <div className={styles.competSubjectTrump}>
                                    <div className={styles.competSubjectBdText}>{item.tView}</div>
                                    {item.tImage && (
                                        <div className={styles.competSubjectBdPic}>
                                            <img className={styles.competSubjectBdImage} src={item.tImage} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {isShowMoreBtn && (
                    <div className={styles.viewMore} onClick={this.handleMoreBtn}>
                        <span className={styles.viewMoreBtn}>查看更多</span>
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(Compet);
